const VIEW_CARD_TOKEN_DATA_KEY = 'view-card-token-data'
export const useViewCardTokenSession = paymentCardId => {
  const setViewCardToken = (token, expirationDate) => {
    const now = Date.now()
    const maxAllowed = now + 10 * 60 * 1000 // Allow max 10 minutes from now
    const finalExpirationTime = Math.min(new Date(expirationDate).getTime(), maxAllowed)
    sessionStorage.setItem(
      VIEW_CARD_TOKEN_DATA_KEY,
      JSON.stringify({
        token,
        expirationTime: finalExpirationTime,
        paymentCardId,
      })
    )
  }
  const removeViewCardToken = () => sessionStorage.removeItem(VIEW_CARD_TOKEN_DATA_KEY)
  const getValidViewCardToken = () => {
    try {
      const viewCardTokenRawData = sessionStorage.getItem(VIEW_CARD_TOKEN_DATA_KEY)
      if (viewCardTokenRawData) {
        const viewCardTokenData = JSON.parse(viewCardTokenRawData)
        if (
          +viewCardTokenData.expirationTime > new Date().getTime() &&
          paymentCardId == viewCardTokenData.paymentCardId
        ) {
          return viewCardTokenData.token
        }
        removeViewCardToken()
      }
    } catch (e) {
      console.error(e)
      removeViewCardToken()
    }
  }
  return { setViewCardToken, getValidViewCardToken, removeViewCardToken }
}
